export const support = {
    CREATE_SUPPORT_MAIL: 'CREATE_SUPPORT_MAIL',
    CREATE_SUPPORT_MAIL_SUCCESS: 'CREATE_SUPPORT_MAIL_SUCCESS',
    CREATE_SUPPORT_MAIL_FAILURE: 'CREATE_SUPPORT_MAIL_FAILURE',

    VERIFY_BUSINESS_REQUEST: 'VERIFY_BUSINESS_REQUEST',
    VERIFY_BUSINESS_SUCCESS: 'VERIFY_BUSINESS_SUCCESS',
    VERIFY_BUSINESS_FAILURE: 'VERIFY_BUSINESS_FAILURE'
}